module.exports = __webpack_public_path__ + "img/FixedTime.8565240b.svg";